import Axios from 'axios';
import { addBaseInterceptors } from './axiosInterceptors';
import { environment } from 'environments/environment';

export const BASE_URL = environment.apiUrl;

export const apiInstance = Axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': '*',
        accept: ' application/json',
        timeout: 10000,
    },
});

addBaseInterceptors(apiInstance);
